import axios from "axios";
const timeout = 60000;
const secFilingsTimeout = 120000;

function clearSession() {
  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user");
  window.location.href = "/login";
}

export const sequireClient = axios.create({
  baseURL: process.env.VUE_APP_SEQUIRE_API_URL || "https://sequire-api-api-816103254658.us-central1.run.app",
  headers: { "Content-Type": "application/json" },
  timeout: timeout,
});

export const secFilingsClient = axios.create({
  baseURL: process.env.VUE_APP_SEC_FILINGS_API_URL || "https://sec-filings-api-816103254658.us-central1.run.app",
  headers: { "Content-Type": "application/json" },
  timeout: secFilingsTimeout,
});

export const reportsConfigClient = axios.create({
  baseURL: process.env.VUE_APP_REPORTS_CONFIG_API_URL || "https://investment-reporter-api-816103254658.us-central1.run.app",
  headers: { "Content-Type": "application/json" },
  timeout: timeout,
});

const authInterceptor = (config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
};

let isRefreshing = false;
let failedQueue = [];

function processQueue(error, token = null) {
  failedQueue.forEach((p) => (error ? p.reject(error) : p.resolve(token)));
  failedQueue = [];
}

const errorInterceptor = async (error) => {
  const originalRequest = error.config;

  if (error.response?.status === 401 && !originalRequest._retry) {
    const storedRefresh = localStorage.getItem("refresh_token");

    if (!storedRefresh) {
      clearSession();
      return Promise.reject(error);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      }).then((token) => {
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return axios(originalRequest);
      });
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      const { data } = await axios.post(
        `${sequireClient.defaults.baseURL}/auth/refresh`,
        { refresh_token: storedRefresh }
      );
      const newAccess = data.access_token;
      localStorage.setItem("token", newAccess);
      localStorage.setItem("refresh_token", data.refresh_token);
      sequireClient.defaults.headers.common.Authorization = `Bearer ${newAccess}`;
      processQueue(null, newAccess);
      originalRequest.headers.Authorization = `Bearer ${newAccess}`;
      return axios(originalRequest);
    } catch {
      processQueue(new Error("Session expired"));
      clearSession();
      return Promise.reject(error);
    } finally {
      isRefreshing = false;
    }
  }

  const message =
    error.response?.data?.error ||
    error.response?.data?.detail ||
    error.response?.data?.message ||
    error.message ||
    "An unexpected error occurred";
  return Promise.reject(new Error(message));
};

sequireClient.interceptors.request.use(authInterceptor);
sequireClient.interceptors.response.use((r) => r, errorInterceptor);

secFilingsClient.interceptors.request.use(authInterceptor);
secFilingsClient.interceptors.response.use((r) => r, errorInterceptor);

reportsConfigClient.interceptors.request.use(authInterceptor);
reportsConfigClient.interceptors.response.use((r) => r, errorInterceptor);
